export default __webpack_public_path__ + "static/belgorod-bacbc297ba6a19719ddc6115b3b31bde.webp";